module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak5.d4abd082.jpg";